import React from "react";
import Logo from "../../logo";
import Searcher from "../../searcher";
import Menu from "../../menu";
import UserPill from "../../user-pill";

const Header1Main = (props) => {
  const {
    logged,
    userName,
    userType,
    mainOptions,
    segmentMenu,
    burgerSections,
    contextLoaded,
    burgerOptions,
    accountSections,
  } = props;
  const selector = logged ? "logged" : "default";

  return (
    <>
      <div className="header1-main container">
        {burgerSections && burgerSections[selector] && (
          <Menu
            layout="burguer"
            items={burgerSections[selector]}
            segmentMenu={segmentMenu[selector]}
            options={burgerOptions[selector]}
            account={accountSections}
          />
        )}
        <div className="logo">
          <Logo />
        </div>
        <div className="searcher">
          <Searcher needOpenModalResults />
        </div>
        <div className="main-left">
          <div className="options">
            {contextLoaded && mainOptions && mainOptions[selector] && (
              <Menu
                items={mainOptions[selector]}
                layout="icons"
                location="all"
              />
            )}
          </div>
          {contextLoaded && logged && (
            <UserPill
              userName={userName}
              userType={userType}
              items={accountSections}
            />
          )}
        </div>
        <style jsx>{`.header1-main {
  position: relative;
  z-index: 50;
  display: flex;
  align-items: center;
  height: 3.5rem;
  background-color: #fff;
  margin: 0 auto;
  :global(.menu-m) {
    :global(img) {
      max-width: unset;
    }
  }
  :global(.menu) {
    :global(.button) {
      display: flex;
      cursor: pointer;
    }
    :global(.button:hover) {
      opacity: 0.5;
    }
    :global(.button:focus) {
      outline: none;
    }
    :global(.modal) {
      position: absolute;
      z-index: 10;
      background-color: #fff;
      display: none;
    }
  }

  .logo {
    margin-left: 4.88%;
    min-width: 7rem;
  }
  .searcher {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .options {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    gap: 1rem;
    :global(.icon-gap) {
      transform: scale(0.9166);
      text-align: center;
    }
    :global(.text-gap) {
      display: none;
    }
    :global(.menu-item) {
      cursor: pointer;
      &:hover {
        opacity: 0.5;
      }
      :global(.usuario-m) {
        :global(img) {
          max-width: unset;
        }
      }
    }
    :global(.menu-item.Tiendas) {
      display: none;
    }
  }
}

@media screen and (min-width: 768px) {
  .header1-main {
    height: 3.75rem;
    .main-left {
      align-items: center;
      min-width: 80px;
      display: flex;
      justify-content: flex-end;
    }
    .options {
      gap: 1rem;

      :global(.menu-item.Tiendas) {
        display: block;
      }
    }
    .searcher {
      width: 100%;
    }
  }
}
@media screen and (min-width: 1024px) {
  .header1-main {
    .logo {
      max-width: 520px;
    }
    .searcher {
      margin-left: 5.883%;
    }
    .main-left {
      min-width: 246px;
      display: flex;
      justify-content: flex-end;
    }
    .options {
      :global(.icon-gap) {
        transform: scale(1);
        :global(svg) {
          vertical-align: middle;
        }
      }
      :global(.text-gap) {
        display: block;
        :global(.text) {
          font-size: 0.875rem;
        }
      }
    }
  }
}
@media screen and (min-width: 1280px) {
  .header1-main {
    height: 5rem;
    .logo {
      margin-left: 3.268%;
      max-width: 520px;
      height: 2rem;
      min-width: 8.375rem;
    }

    .main-left {
      min-width: 368px;
      display: flex;
      justify-content: flex-end;
    }
    .options {
      min-width: 136px;
      :global(.text-gap) {
        :global(.text) {
          font-size: 0.875rem;
        }
      }
    }
  }
}`}</style>
      </div>
    </>
  );
};
export default Header1Main;
